const App__microsite = {
  header: null,
  mobileTrigger: null,
  mainNav: null,
  utilityNav: null,
  aside: null,
  skipContent: null,

  appHeader__wantToWrapper: null,

  appHeader__search: null,
  appHeader__searchInput: null,
  appHeader__searchForm: null,
  micrositeHeader__searchIconClose: null,
  micrositeHeader__searchIconOpen: null,

  init: function () {
    try {
      this.header = document.querySelector("[data-hook=micrositeHeader");

      if (this.header === undefined || this.header === null) return;

      this.mobileTrigger = document.querySelector(
        "[data-hook=micrositeHeader__mobileTrigger"
      );

      this.mainNav = document.querySelector("[data-hook=microsite__mainNav]");

      if (
        this.mobileTrigger === undefined ||
        this.mobileTrigger === null ||
        this.mainNav === undefined ||
        this.mainNav === null
      )
        return;

      this.utilityNav = this.mainNav.querySelector(
        "[data-hook=micrositeHeader__utilityNav]"
      );

      this.aside = this.mainNav.querySelector("aside");
      this.skipContent = this.mainNav.querySelector(".subpage__aside-nav-skip");

      // Init Want To controls.
      this.appHeader__wantToWrapper = document.querySelector(
        "[data-hook=appHeader] [data-hook=appHeader__wantToWrapper]"
      );

      // Init Search controls
      this.appHeader__search = document.querySelector(
        "[data-hook=appHeader__search]"
      );
      this.appHeader__searchInput = document.querySelector(
        "[data-hook=appHeader__searchInput]"
      );
      this.appHeader__searchForm = document.querySelector(
        "[data-hook=appHeader__searchForm]"
      );

      this.micrositeHeader__searchIconClose = document.querySelector(
        "[data-hook=micrositeHeader__searchIconClose]"
      );
      this.micrositeHeader__searchIconOpen = document.querySelector(
        "[data-hook=micrositeHeader__searchIconOpen]"
      );

      this.listenToTrigger();

      this.maybeRemoveSkipContent();
    } catch (e) {
      console.error(e);
    }
  },

  /***
   *
   * LISTENER METHODS
   *
   */
  listenToTrigger: function () {
    this.mobileTrigger.addEventListener("click", function (e) {
      App__microsite.handleToggleNavs();
    });

    /* Click handler for: appHeader__wantTo
     * Toggles "I want to..." panel
     * =========================================================================== */
    if (this.appHeader__wantToWrapper !== undefined &&
      this.appHeader__wantToWrapper !== null) {
        document.addEventListener("click", (e) => {
          // Safety retun incase the wrapper didn't get set.
          if (this.appHeader__wantToWrapper === null) {
            return;
          }

          if (!e.target.matches("[data-hook=appHeader__wantTo]")) {
            // Check for and close wantTo
            if (
              this.element &&
              this.appHeader__wantToWrapper.classList.contains("is-open")
            ) {
              this.wantTo__close();
            }

            return false;
          }
          e.preventDefault();

          if (
            this.appHeader__wantToWrapper.getAttribute("aria-hidden") == "true"
          ) {
            this.wantTo__open();
          } else {
            this.wantTo__close();
          }
        });
    }
    

    /* Click handler for: appHeader__wantTo
     * Toggles "I want to..." panel
     * =========================================================================== */
    if (
      this.appHeader__search !== undefined &&
      this.appHeader__search !== null
    ) {
      this.appHeader__search.addEventListener(
        "shown.bs.collapse",
        (event) => {
          this.micrositeSearch__init_focus();
        }
      );

      this.appHeader__search.addEventListener(
        "hidden.bs.collapse",
        (event) => {
          this.micrositeSearch__reset_focus();
        }
      );
    }
  },

  closeOverlayPanels: function () {
    this.handleClose();
    this.wantTo__close();
    // this.micrositeSearch__close();
  },

  /***
   *
   * HANDLER METHODS
   *
   */

  handleClose: function () {
    this.mobileTrigger.setAttribute("aria-expanded", false);

    this.mainNav.style.display = "none";
    this.mainNav.setAttribute("aria-hidden", true);

    if (this.utilityNav !== undefined && this.utilityNav !== null) {
      this.utilityNav.style.display = "none";
      this.utilityNav.setAttribute("aria-hidden", true);
    }
  },

  handleOpen: function () {
    this.micrositeSearch__close();

    this.mobileTrigger.setAttribute("aria-expanded", true);

    this.mainNav.style.display = "block";
    this.mainNav.setAttribute("aria-hidden", false);

    if (this.utilityNav !== undefined && this.utilityNav !== null) {
      this.utilityNav.style.display = "block";
      this.utilityNav.setAttribute("aria-hidden", false);
    }

    if (this.aside !== undefined && this.aside !== null) {
      this.aside.classList.add("d-block");
    }
  },

  handleToggleNavs: function () {
    if (this.mainNav.style.display === "block") {
      this.handleClose();
    } else {
      this.handleOpen();
    }
  },

  maybeRemoveSkipContent: function () {
    // Maybe Remove the skipContent element from the mobile navigation.
    if (this.skipContent !== undefined && this.skipContent !== null) {
      this.skipContent.remove();
    }
  },

  // Want To
  //=====================================================
  wantTo__open: function () {
    this.appHeader__wantToWrapper.setAttribute("aria-hidden", false);
    this.appHeader__wantToWrapper.classList.add("is-open");
  },

  wantTo__close: function () {
    this.appHeader__wantToWrapper.setAttribute("aria-hidden", true);
    this.appHeader__wantToWrapper.classList.remove("is-open");
  },

  // Search
  //=====================================================
  micrositeSearch__init_focus: function () {
    // Close competing panels
    this.handleClose();

    // Scroll to top so that the search form is in view
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera

    this.micrositeHeader__searchIconClose?.classList.remove("d-none");
    this.micrositeHeader__searchIconOpen?.classList.add("d-none");
  },

  micrositeSearch__reset_focus: function () {
    this.micrositeHeader__searchIconClose?.classList.add("d-none");
    this.micrositeHeader__searchIconOpen?.classList.remove("d-none");
  },

  micrositeSearch__close: function () {
    if (
      this.appHeader__search === undefined ||
      this.appHeader__search === null ||
      !this.appHeader__search.classList.contains("show")
    )
      return;

    const searchCollapse = new App.bootstrap.Collapse(this.appHeader__search);
    searchCollapse.hide();
  },
};

export default App__microsite;
